
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import PaperbackLogo from '@/common/components/ui/PaperbackLogo.vue'
import SidebarBaseButton from '@/common/components/ui/SidebarBaseButton.vue'
import MenuButton from '@/common/components/ui/MenuButton.vue'
import { useQuery, useResult } from '@vue/apollo-composable'
import { GET_USER_QUERY } from '@/services/apollo/requests'
import { GraphQLUserData } from '@/services/apollo/types'

export default defineComponent({
    name: 'TheSidebar',
    components: {
        PaperbackLogo,
        SidebarBaseButton,
        MenuButton,
    },
    setup() {
        const store = useStore()
        const router = useRouter()

        const colorMode = computed(() => store.getters['ui/colorMode'])

        const menuState = computed(() => store.getters['ui/menuState'])

        const signOut = () => {
            store.dispatch('auth/clearStaleState').then()
            store.dispatch('auth/removeOidcUser').then(() => router.push('/'))
            store.dispatch('ui/setMenuState', 'closed')
        }

        const { result } = useQuery(GET_USER_QUERY)
        const isPatron = useResult(result, false, (data: GraphQLUserData) =>
            data?.getUserData?.patreonStatus ? true : false
        )

        return {
            colorMode,
            signOut,
            isPatron,
            menuState,
        }
    },
})
